import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const burnTreasuryAddress = (data) => request.post(`${API_BASE_URL}/blockchain/addresses/burn-treasury`, data)

export default burnTreasuryAddress